import * as React from "react";

export const ExpiringIcon: React.FC<React.SVGProps<SVGElement>> = ({
  color = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <g clipPath="url(#a)">
      <path
        fill={color}
        d="M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m0 1.8a5.2 5.2 0 1 0 0 10.4A5.2 5.2 0 0 0 7 1.8m-.001 1.263c.483 0 .875.391.875.874V7.8l-.256.258-1.75 1.749a.875.875 0 0 1-1.237-1.238l1.494-1.494V3.938c0-.483.391-.875.874-.876"
      ></path>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
